module.exports = __webpack_public_path__ + "img/IT0000040113343.a9bead5e.png";